import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useExpenseReportFilterFields } from './hooks/useExpenseReportFilterFields';

export const ExpenseReportListFilterChips = () => {
  const fields = useExpenseReportFilterFields();

  return <FilterChips fields={fields} />;
};
